define('viewModels/privileged/composer/forms/EvaluationFormEditor',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'services/loggingService',
    'viewModels/ViewModel',
    'services/composer/evaluationFormService',
    'services/qm/qualityAuth',
    'services/navHelper',
    'services/routeService',
    'services/composer/templateService',
    'models/composer/forms/Evaluation',
    'viewModels/privileged/composer/forms/formEditor/Evaluation',
    'viewModels/privileged/composer/forms/formEditor/FormEditorState',
    'viewModels/privileged/composer/forms/formEditor/FormErrorDialogView',
    'services/toastService'
], function (
    $,
    ko,
    _,
    Promise,
    loggingService,
    ViewModel,
    evaluationFormService,
    qualityAuth,
    navHelper,
    routeService,
    templateService,
    EvaluationModel,
    EvaluationViewModel,
    FormEditorState,
    FormErrorDialogView,
    toastService
) {
    'use strict';

    var EDITOR_PAGE_HASH = "#admin/evaluationForms/";//+id;
    var LIST_PAGE_HASH = "#admin/evaluationForms";

    var NEW_EVALUATION_DATA = {
        "type":  "evaluation",
        "questionGroups": [
            {
                "type": "questionGroup",
                "optional": false,
                "notes": "Default question group",
                "questions": []
            }
        ],
        "version": 0
    };

    var EvaluationFormEditorViewModel = ViewModel.extend(function evaluationFormEditorVm_init(options) {
        var self = this;

        self.evaluation = ko.observable(); //ViewModel

        self.isLoading = ko.observable();
        self.saving = ko.observable();
        self.publishing = ko.observable();

        var formEditorState = options && options.formEditorState ? options.formEditorState : new FormEditorState();

        //Adds isPreviewMode, isEditMode, isEvaluatorActionMode, etc.
        _.extend(self, formEditorState.modes);

        self.validationErrorDialog = self.subView(FormErrorDialogView, formEditorState.validationErrors, {
            cancellable: true,
            onCancel: function() {
                self.validationErrorDialog.showInlineDialog(false);
                formEditorState.validationErrors([]);
            }
        });

        function selectDefaultAnswers() {
            if(self.evaluation()) {
                self.evaluation().selectDefaultAnswers();
            }
        }

        //Used by the preview mode checkbox
        self.togglePreview = self.computed({
            read: function () {
                return self.isPreviewMode();
            },
            write: function (newVal) {
                if(newVal) {
                    //*
                    formEditorState.setPreviewMode();
                    /*/
                    formEditorState.setEvaluatorActionMode();
                    //*/
                    selectDefaultAnswers();
                } else {
                    formEditorState.setEditMode();
                    formEditorState.hasScoreChanged(true); //Assume that the scoring has changed once we start editing
                }

            }
        });


        self.isModified = formEditorState.isModified;

        var namesList = ko.observableArray();

        function updateNamesList() {
            evaluationFormService.get.page().then(function (page) {

                //Get all the remaining pages, so we have a complete list of names
                var pagePromises = _.range(2, page.pageCount+1).map(function (pageNumber) {
                    return evaluationFormService.get.page({pageNumber: pageNumber});
                });

                //pagePromises might be empty if there's only a single page, in which case the promise immediately resolves with []
                Promise.all(pagePromises).then(function(pages) {
                    var allForms = [].concat.apply(page.entities, _.map(pages, "entities"));

                    //For each form, add a name-id pair to the namesList
                    namesList(allForms.map(function (form) {
                        return _.pick(form, ["id", "name"]); //Only take the id and name
                    }));
                });

            });
        }
        updateNamesList();

        self.evaluationValid = self.computed(function evaluationFormEditorVm_evaluationValid() {
            var evaluation = self.evaluation();
            return evaluation && evaluation.isValidForSaving();
        });
        self.canSave = self.computed(function evaluationFormEditorVm_canSave() {
            return self.isModified() && !self.saving() && self.evaluationValid();
        });
        self.canPublish = self.computed(function evaluationFormEditorVm_canPublish() {
            return !self.isModified() && !self.publishing() && self.evaluationValid();
        });
        self.isPublished = self.computed(function evaluationFormEditorVm_isPublishedRead() {
            var evaluationViewModel = self.evaluation();
            if (!evaluationViewModel) {
                return false;
            }
            return evaluationViewModel.isPublished();
        });
        self.canEdit = self.computed(function evaluationFormEditorVm_canEdit() {
            var isNew = ko.unwrap(self.evaluation) && evaluationId === "new";
            return !self.isPublished() &&
                (qualityAuth.canEditEvaluationForm() || (qualityAuth.canAddEvaluationForm() && isNew));
        });

        self.configure = function (newId) {
            loadEvaluation(newId);
            // Default to edit if they can edit
            self.togglePreview(!self.canEdit());
        };

        var evaluationId;
        function loadEvaluation(newId) {
            evaluationId = newId;
            self.isLoading(true);
            self.evaluation(null);
            formEditorState.hasScoreChanged(true); //Force a scoring as soon as we enter preview mode
            if(newId === "new") {
                //Create new evaluation
                var newData = NEW_EVALUATION_DATA;
                var evaluationModel = new EvaluationModel(newData);
                self.setEvaluation(evaluationModel);
                self.isLoading(false);
            } else {
                //Load existing evaluation
                if (self.canEdit()) {
                    evaluationFormService.get.byId(newId).then(function evaluationFormEditorVm_loadEvaluation_getByIdThen(model) {
                        if (evaluationId !== newId) { //check race condition, TODO - look into cancellable promises
                            return;
                        }
                        self.setEvaluation(model);
                        self.isModified(false);
                        // prevent client side editing if the evaluation form has been published.
                        if (model.published()) {
                            formEditorState.setPreviewMode();
                            selectDefaultAnswers();
                        }
                        self.isLoading(false);

                    }).catch(function evaluationFormEditorVm_loadEvaluation_getByIdCatch(err) {
                        if (evaluationId !== newId) {
                            return;
                        }
                        loggingService.error("EvaluationFormService Load failed", err);
                        toastService.notifyMinorAlert(
                            'composer.evaluations.editor.loadFail.title',
                            {
                                bodyMessageKey: 'composer.evaluations.editor.loadFail.message'
                            }
                        );
                        self.isLoading(false);
                        self.evaluation(null); //helpful for unit tests to detect that loading failed;
                        navHelper.navigateTo(LIST_PAGE_HASH); //No evaluation found; display the list page
                    });
                } else {
                    navHelper.navigateTo(LIST_PAGE_HASH);
                }
            }
        }

        self.setEvaluation = function (model) {
            if (model !== null) {
                var evaluationViewModel = self.subView(EvaluationViewModel, model, namesList, formEditorState);
                if (self.evaluation()) {
                    self.disposeSubView(self.evaluation());
                }
                self.evaluation(evaluationViewModel);
            } else {
                self.evaluation(null);
            }
            self.loadTemplates();
        };

        self.loadTemplates = function () {
            //Retrieve the list of question templates
            var templatesPromise = templateService.getUserTemplates(templateService.EVALUATIONS_SERVICE, {
                tags: "question",
                expand: "data" //Include the template data in the response
            })
            .then(function (templateData) {
                formEditorState.questionTemplates(templateData.entities);
            });

            var favoritesPromise = templateService.getFavoriteTemplateIds(templateService.EVALUATIONS_SERVICE)
            .then(function (templateIds) {
                formEditorState.favoriteTemplateIds(templateIds);
            });

            //Combine error reporting so we don't double report the template service failure to the user
            Promise.join(templatesPromise, favoritesPromise)
            .catch(function () {
                toastService.notifyMinorAlert(
                    'composer.evaluations.editor.templates.getAll.failure.title',
                    {
                        bodyMessageKey: 'composer.evaluations.editor.templates.getAll.failure.message'
                    }
                );
            });
        };

        self.saveBtnText = self.computed(function evaluationFormEditorVm_saveBtnText() {
            if(self.saving()) {
                return 'composer.evaluations.editor.saving';
            }
            return 'composer.evaluations.editor.save';
        });

        self.publishBtnText = self.computed(function evaluationFormEditorVm_publishBtnText() {
            if(self.publishing()) {
                return 'composer.evaluations.editor.publishing';
            }
            return 'composer.evaluations.editor.publish';
        });

        self.backBtnText = self.computed(function evaluationFormEditorVm_backBtnText() {
            if(self.isModified()) {
                return 'composer.evaluations.editor.backToListWarning';
            }
            return 'composer.evaluations.editor.backToList';
        });

        self.backBtnClass = self.computed(function evaluationFormEditorVm_backBtnClass() {
            if(self.isModified()) {
                return 'back-btn-danger';
            }
            return 'back-btn-safe';
        });

        $(window).off('beforeunload.evalForms');
        $(window).on('beforeunload.evalForms', function(evt) { return self.onLeavingSite(evt); });

        // This is called when the user is navigating away from the site
        self.onLeavingSite = function(evt) {
            var evaluation = self.evaluation();
            if (!evaluation || self.saving() || !self.canSave()) {
                return;
            }
            var confirmMsg = ko.i18n.renderString("composer.evaluations.editor.unsavedConfirmNavigationOffsite");
            var e = (evt || window.event);
            if (e) {
                e.returnValue = confirmMsg; // Gecko, IE
            }
            return confirmMsg; // Webkit
        };

        // This may be called when leaving an individual eval form page, but staying within the site (i.e. when the location hash is changing)
        self.promptToSaveUnsavedChanges = function() {
            $(window).off('beforeunload.evalForms');
            var evaluation = self.evaluation();
            if (!evaluation || self.saving() || !self.canSave()) {
                return true;
            }
            var savePrompt = ko.i18n.renderString("composer.evaluations.editor.unsavedConfirmNavigationWithinSite");
            var userWantsToSave = window.confirm(savePrompt);
            if (userWantsToSave) {
                self.saveEvaluation();
            }
            return true;
        };

        self.subscribe(formEditorState.validationErrors, function (validationErrors) {
            if (validationErrors.length) {
                self.validationErrorDialog.showInlineDialog(true);
            }
        });

        // Triggered by Save button on EvaluationFormEditor
        self.saveEvaluation = function () {
            var evaluation = self.evaluation();
            if (!evaluation || self.saving() || !self.canSave()) {
                return;
            }
            self.saving(true);
            var unwrappedEvaluationModel = evaluation.getUnwrappedComposerModel();
            var promise;
            if(evaluationId === "new") {
                promise = evaluationFormService.post.create(unwrappedEvaluationModel);
            }
            else {
                promise = evaluationFormService.put.update(evaluationId, unwrappedEvaluationModel);
            }
            promise.then(function evaluationFormEditorVm_saveEvaluationThen(dataFromPost) {
                if(evaluationId === "new") {
                    evaluationId = dataFromPost.id;
                    var newEvaluationModel = new EvaluationModel(dataFromPost);
                    self.setEvaluation(newEvaluationModel);
                    window.history.replaceState({}, "", EDITOR_PAGE_HASH+dataFromPost.id);
                }
                self.isModified(false);
                toastService.notifyMessage(
                    'composer.evaluations.editor.saveSuccess.title',
                    {
                        bodyMessageKey: 'composer.evaluations.editor.saveSuccess.message',
                        icon: "fa-check-circle"
                    }
                );
                self.saving(false);
            })
            .catch(function evaluationFormEditorVm_saveEvaluationCatch(err) {
                loggingService.error("EvaluationFormService Save failed", err);
                if(err.details && err.details.status === 409) { //409-CONFLICT
                    toastService.notifyMinorAlert(
                        'composer.evaluations.editor.evaluation.duplicateNameError.title',
                        {
                            bodyMessageKey: 'composer.evaluations.editor.evaluation.duplicateNameError.message'
                        }
                    );
                    namesList.push({ //Add the name to our names list to immediately give local validation error
                        name: evaluation.name()
                    });
                    updateNamesList(); //Update the names list to get other changes
                } else {
                    toastService.notifyMinorAlert(
                        'composer.evaluations.editor.saveFail.title',
                        {
                            bodyMessageKey: 'composer.evaluations.editor.saveFail.message'
                        }
                    );
                }
                self.saving(false);
            });
        };

        // Triggered by Publish button on EvaluationFormEditor
        self.publishEvaluation = function () {
            var evaluation = self.evaluation();
            if (!evaluation || self.publishing() || !self.canPublish()) {
                return;
            }
            self.publishing(true);
            var evaluationModel = evaluation.getModel();
            evaluationFormService.post.publish(evaluationModel.id)
            .then(function evaluationFormEditorVm_publishEvaluation_EvaluationFormServicePostPublishThen() {
                toastService.notifyMessage(
                    'composer.evaluations.editor.publishSuccess.title',
                    {
                        bodyMessageKey: 'composer.evaluations.editor.publishSuccess.message',
                        icon: "fa-check-circle"
                    }
                );
                self.publishing(false);
                navHelper.navigateTo(LIST_PAGE_HASH);
            })
            .catch(function evaluationFormEditorVm_publishEvaluation_publishEvaluationServiceCallFinally() {
                toastService.notifyMinorAlert('composer.evaluations.editor.publishFail', {delay: toastService.DELAY_LONG});
                toastService.notifyMinorAlert(
                    'composer.evaluations.editor.publishFail.title',
                    {
                        bodyMessageKey: 'composer.evaluations.editor.publishFail.message'
                    }
                );
                self.publishing(false);
            });
        };

        // Triggered by Navigate Back button on EvaluationFormEditor
        self.navigateBack = function () {
            navHelper.navigateTo(LIST_PAGE_HASH);
        };

        self.triggerSelect = function (vm, e) {
            var evt = e.originalEvent || e; //originalEvent, if we've hit a jQuery callback at some point
            if(!evt.ccPreventDeselect) {
                formEditorState.selectedItem(null);
            }
            if(!evt.ccPreventDeselectAddQuestionBar) {
                formEditorState.selectedAddQuestionBar(null);
            }
            // NOTE: This must be here to allow checkboxes (etc) to be checked
            return true;
        };
    });

    return EvaluationFormEditorViewModel;
});

